import {registerMPElement} from '../../../util/register-element';
import {SlidingPaneDropdown} from '../common-components/sliding-pane-dropdown/index';
import {BuilderType} from '../models/enums/builder-enums';
import {isDefinedValue} from '../util/index';

import './builder-clause-operator/index';
import './builder-distinct-day';
import './builder-condition';
import './builder-frequency';
import './builder-property-filter';
import './builder-time';

export default registerMPElement(
  `cohorts-builder-pane-dropdown`,
  class CohortsBuilderPaneDropdown extends SlidingPaneDropdown {
    get config() {
      return {
        ...super.config,
        useShadowDom: true,
        helpers: {
          ...super.config.helpers,
          dropMenuChanged: (ev) => {
            if (ev.detail && ev.detail.state === `open`) {
              this._builderType = this.builderState.builderType;
              this._stagedClause = this.state.stagedClausePosition;
              this._propertyFilterIdx = this.builderState.propertyFilterIdx;
            } else if (ev.detail && ev.detail.state === `closed`) {
              this.closeBuilder();
            }
          },
        },
      };
    }

    get placeholderPaneWidth() {
      switch (this.builderState.builderType) {
        case BuilderType.PropertyFilter:
        case BuilderType.Condition:
          return 320;
        default:
          return 0;
      }
    }

    get builderType() {
      return this._builderType || this.builderState.builderType;
    }

    get stagedClause() {
      return this._stagedClause || this.state.stagedClausePosition;
    }

    get propertyFilterIdx() {
      return isDefinedValue(this._propertyFilterIdx) || this._propertyFilterIdx === null
        ? this._propertyFilterIdx
        : this.builderState.propertyFilterIdx;
    }

    closeBuilder() {
      this.app.closeBuilder(this.builderType, this.stagedClause, this.propertyFilterIdx);
    }
  },
);
